export enum ButtonLabel {
    OUT_OF_STOCK = 'Out of stock',
    SELECT_A_VARIANT = 'Select a variant',
    ADD_TO_CART = 'Add to Bag',
    UPDATE_CART_ITEM = 'Update',
    SET_UP_NOW = 'Set Up Now',
    BUY_NOW = 'Buy Now'
}
